/**
 * 受注モーダル一覧からの登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/drivers`

const allocation_driver_appender = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 配車予定(日, 週)で表示するドライバーの配車予定一覧
     * @param commit
     * @param driver_id
     * @param target_date
     * @return {Promise<unknown>}
     */
    index({ commit }, { driver_id, target_date }) {
      const params = {
        target_date: target_date
      }
      const api_path = `${API_PATH}/${driver_id}/assigns`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 受注一覧モーダル ドライバーと受注の紐付け
     * @param commit
     * @param driver_id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { driver_id, params }) {
      const api_path = `${API_PATH}/${driver_id}/assigns`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          if (data.result.code) {
            commit('snackbar/showError', { message: data.result.message }, { root: true })
          } else {
            commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          }
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}
export default allocation_driver_appender

